<div class="staffmember">
  <div *ngIf="staffMember">
    <h2>{{staffMember.name}}</h2>
    <img src='/images/photos/{{staffMember.id}}.dj.jpg' alt="{{staffMember.name}}">
    <div class='description' [innerHTML]="staffMember.description|nl2pbr|sanitizeHtml"></div>
    <div class='clearer'></div>
    <div *ngIf='isAdmin'> <a routerLink="/beheer/staff/{{staffMember.id}}">Aanpassen</a></div>
  </div>
</div>
